var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockFilledPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 6.66683H14.9997C15.9163 6.66683 16.6663 7.41683 16.6663 8.3335V9.2259C16.3942 9.18697 16.1159 9.16683 15.833 9.16683C12.6113 9.16683 9.99967 11.7785 9.99967 15.0002C9.99967 16.2395 10.3862 17.3886 11.0452 18.3335H4.99967C4.08301 18.3335 3.33301 17.5835 3.33301 16.6668V8.3335C3.33301 7.41683 4.08301 6.66683 4.99967 6.66683H12.583V5.00016C12.583 3.57516 11.4247 2.41683 9.99967 2.41683C8.57467 2.41683 7.41634 3.57516 7.41634 5.00016H5.83301C5.83301 2.70016 7.69967 0.833496 9.99967 0.833496C12.2997 0.833496 14.1663 2.70016 14.1663 5.00016V6.66683Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6663 15.0002C11.6663 12.7002 13.533 10.8335 15.833 10.8335C18.133 10.8335 19.9997 12.7002 19.9997 15.0002C19.9997 17.3002 18.133 19.1668 15.833 19.1668C13.533 19.1668 11.6663 17.3002 11.6663 15.0002ZM17.083 13.7502C17.083 13.0585 16.5247 12.5002 15.833 12.5002C15.1413 12.5002 14.583 13.0585 14.583 13.7502C14.583 14.4418 15.1413 15.0002 15.833 15.0002C16.5247 15.0002 17.083 14.4418 17.083 13.7502ZM13.7663 16.4002C14.2163 17.0668 14.9747 17.5002 15.833 17.5002C16.6913 17.5002 17.4497 17.0668 17.8997 16.4002C17.2913 16.0502 16.5913 15.8335 15.833 15.8335C15.0747 15.8335 14.3747 16.0502 13.7663 16.4002Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockFilledPerson);
export default __webpack_public_path__ + "static/media/unlockFilledPerson.91e079f1962c06daca01bdaa6312f530.svg";
export { ForwardRef as ReactComponent };